export class Filter {

    fromDate: Date;
    toDate: Date;
    contractStartFrom: Date;
    contractStartTo: Date;
    contractEndFrom: Date;
    contractEndTo: Date;
    keyword: string;
    brand: string = null;
    status: string = null;
    contractTypeId: number = null;
    dealerName: string = null;
    dealerNumber: string = null;
    vin: string;
    page: number = 0;
    pageSize: number = 20;
    orderBy: string;
    order: string = 'ASC';

}

export class ReportFilter{
  page: number = 0;
  pageSize: number = 20;
  dealerNumber: string = null;
  orderBy: string ;
  order: string = 'ASC';
  invoicedDateFrom: Date;
  invoicedDateTo: Date;
}
